import { TaskStatus } from '../adminDashboard/adminTasks'
import { adminHttpClient } from '../commons/adminHttpClient'

export type AdminTaskResponse = {
  id: number
  name: string
  description: string
  icon: string
  priority: number
  status: TaskStatus
  allowReview: boolean
}

const getRenewalTasks = async (): Promise<AdminTaskResponse[]> => {
  return await adminHttpClient.get(`/Tasks/RenewalTasks`)
}

export default getRenewalTasks
